// extracted by mini-css-extract-plugin
export default {"defaults":"Spacer_defaults__UDzPQ","small":"Spacer_small__3FTRZ","medium":"Spacer_medium__slWfz","large":"Spacer_large__QcGKy"};